import { createReducer, on } from '@ngrx/store';
import { clearStateRequested } from '../auth/auth.actions';
import * as patientActions from '../patient/patient.actions';
import * as patientTaskActions from './patient-task.actions';

export interface State {
	selectedTaskId: string;
	selectedDocumentInstanceId: string;
}

export const initialState: State = {
	selectedTaskId: '',
	selectedDocumentInstanceId: ''
}

export const patientTaskReducer = createReducer(
	initialState,
	on(patientTaskActions.subscribeVisitTaskRequested, (state, { taskId }) => ({
		...state,
		selectedTaskId: taskId,
		selectedDocumentInstanceId: ''
	})),
	on(patientTaskActions.subscribedVisitTaskLoaded, (state, { documentInstanceId }) => ({
		...state,
		selectedDocumentInstanceId: documentInstanceId
	})),
	on(patientTaskActions.addVisitTaskRequested, (state) => ({
		...state,
		selectedTaskId: '',
		selectedDocumentInstanceId: ''
	})),
	on(patientTaskActions.addVisitTaskCompleted, (state, { taskId }) => ({
		...state,
		selectedTaskId: taskId
	})),
	on(patientTaskActions.addedVisitTaskLoaded, (state, { documentInstanceId }) => ({
		...state,
		selectedDocumentInstanceId: documentInstanceId
	})),
	on(patientTaskActions.showLoadedVisitTaskRequested, (state, { taskId }) => ({
		...state,
		selectedTaskId: taskId,
		selectedDocumentInstanceId: ''
	})),
	on(patientTaskActions.showLoadedVisitTaskCompleted, (state, { documentInstanceId }) => ({
		...state,
		selectedDocumentInstanceId: documentInstanceId
	})),
	on(patientTaskActions.hideLoadedVisitTaskRequested, (state) => ({
		...state,
		selectedTaskId: '',
		selectedDocumentInstanceId: ''
	})),
	on(patientTaskActions.visitDocumentInstanceSelected, (state, { documentInstanceId }) => ({
		...state,
		selectedDocumentInstanceId: documentInstanceId
	})),
	on(patientTaskActions.visitDocumentInstanceDeselected, (state) => ({
		...state,
		selectedDocumentInstanceId: ''
	})),
	on(patientTaskActions.copyVisitTaskRequested, (state) => ({
		...state,
		selectedTaskId: '',
		selectedDocumentInstanceId: ''
	})),
	on(patientTaskActions.copyVisitTaskCompleted, (state, { taskId }) => ({
		...state,
		selectedTaskId: taskId
	})),
	on(patientActions.patientDeselected, () => initialState),
	on(clearStateRequested, () => initialState)
);
